<template>
  <b-modal :active.sync="is_open"
           has-modal-card
           trap-focus
           :destroy-on-hide="false"
           aria-role="dialog"
           aria-modal>
    <form action="">
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">ストックに追加</p>
        </header>
        <section class="modal-card-body">
          <b-button type="is-danger" expanded outlined
            v-for="lst in create_list" :key="lst.list_id"
            @click="add_tweet_to_target_list(lst.list_id, tweet_id)">
            {{lst.list_name}} <span class="is-size-7">({{lst.length}})</span>
          </b-button>
        </section>
        <footer class="modal-card-foot" style="justify-content: flex-end;">
          <b-field>
            <b-input placeholder="新しいリストの名前" v-model="new_list_name"
             minlength="3" maxlength="30" expanded></b-input>
            <p class="control">
              <span class="button is-success" @click="create_mylist()">作成</span>
            </p>
          </b-field>
        </footer>
      </div>
    </form>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      create_list: [],
      new_list_name: "",
      is_open: false,
    }
  },
  props: {
    tweet_id: String,
    value: Boolean,
  },
  computed: {
    user_info: function () {
      let ret_info = this.$store.getters['getUserInfo']
      return JSON.parse(JSON.stringify(ret_info))
    }
  },
  watch: {
    user_info: {
      handler: "get_createlists",
      immediate: true,      
    },
    value() {
      if(this.value == true){
        this.is_open = this.value
      }
    },
    is_open() {
      if(this.is_open == false){
        this.$emit("input", false)
      }
    }
  },
  methods: {
    add_tweet_to_target_list(list_id, tweet_id) {
      this.$store.commit("addTweetToList", {list_id:list_id, tweet_id:tweet_id})
      this.$emit("add-tweet")
      this.is_open = false
    },
    create_mylist() {
      this.$store.dispatch("createNewMylist", this.new_list_name).then((result) => {
        if(result == true){
          this.$buefy.toast.open('新しいストックを作成しました！')
        }
        else{
          this.$buefy.toast.open(`「${this.new_list_name}」は作成できないストック名です`)
        }
        this.new_list_name = ""
      }).catch(() => {
        this.$buefy.toast.open('ストックが作成できませんでした')
      })
    },
    get_createlists() {
      this.create_list = this.$store.getters.getCreateLists.map((val) => {
        val.length = this.$store.getters.getCreateListLength(val.list_name)
        return val
      })
      this.create_list.splice()
    }
  }
}
</script>

<style>
button {
  margin-bottom: 0.3em;
}
</style>